import React, { useEffect, useRef } from 'react';
import { useRouting } from 'hooks/useRouting';
import { useParams } from 'react-router-dom';
import { footerText } from './InvestorIdExplanation';

const InvestorIdRegistrationError: React.FC = () => {
  const { type } = useParams<{ type: string }>(); // exception: 接続切れ, duplication: 重複エラー
  const routing = useRouting();
  const unmounted = useRef<boolean>(false);
  const url = '/Auth?callbackPath=/home';

  const goBack = () => {
    routing.backRouting(true);
  };

  const update = () => {
    window.location.href = url;
  };

  useEffect(() => {
    if (type === 'exception') unmounted.current = true;
    if (unmounted.current) return;

    setTimeout(() => {
      window.location.href = url;
    }, 30000);
    unmounted.current = true;

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="max-w-md mx-auto relative">
      <div className="p-6 bg-white text-bluegray-700">
        <div className="flex justify-center mx-auto lg:w-1/2 w-full">
          {type === 'duplication' ? (
            <img
              src="/static/images/investorid_error_duplication.svg"
              alt=""
              width="180"
              height="180"
            />
          ) : (
            <img
              src="/static/images/investorid_error_exception.svg"
              alt=""
              width="180"
              height="180"
            />
          )}
        </div>
        <div className="mt-4 text-lg font-bold text-center leading-7">
          {type === 'duplication' ? (
            <>
              ただいまお手続き中です
              <br />
              お待ちください
            </>
          ) : (
            <>
              接続が切れてしまったため
              <br />
              登録に失敗しました
            </>
          )}
        </div>
        {type === 'duplication' ? (
          <>
            <div className="mt-4 text-sm text-center">
              お手続きが完了したら自動で画面が更新されます
            </div>
            <div
              className="w-full mt-4 py-2 px-2 text-base font-bold text-white bg-bluegray-700 text-center rounded-lg shadow cursor-pointer"
              onClick={(): void => update()}>
              画面を更新する
            </div>
          </>
        ) : (
          <></>
        )}
        {type === 'exception' ? (
          <>
            <div className="mt-4 text-sm text-center leading-6">
              お手数ですが、下記のリンクより
              <br />
              もう一度やり直してください。
            </div>
            <div className="pt-3 text-sm text-link text-center cursor-pointer">
              <div onClick={goBack}>もう一度やり直す</div>
            </div>
          </>
        ) : (
          <></>
        )}
        <div className="mt-10 text-xs text-center leading-5">
          {type === 'duplication' ? (
            <>
              ※1営業日以上経過しても本画面が
              <br />
              表示される場合はお問い合わせください
            </>
          ) : (
            <>
              ※複数回やり直しても解消しない場合は
              <br />
              お問い合わせください
            </>
          )}
        </div>
        <div className="pt-3 pb-8 text-sm text-link text-center">
          <a
            href="https://support.minkabu.jp/hc/ja/requests/new?ticket_form_id=360002511233"
            target="_blank"
            rel="noopener noreferrer">
            お問い合わせ
          </a>
        </div>
      </div>
      {footerText()}
    </div>
  );
};

export default InvestorIdRegistrationError;
